import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerCompanyInfoService,
  CustomerCompanyInfoModel,
  CustomerAddressRequest,
  CustomerCompanyDetailsUpdateRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CustomerCompanyInfoApiService {
  constructor(private apiService: CustomerCompanyInfoService) {}

  public updateAddress(customerId: string, body: CustomerAddressRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerCompanyInfoModel> {
    return this.apiService.customerCompanyInfoAddress(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public updateCompanyDetails(customerId: string, body: CustomerCompanyDetailsUpdateRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerCompanyInfoModel> {
    return this.apiService.customerCompanyInfoCompanyDetails(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCompanyInfo(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerCompanyInfoModel> {
    return this.apiService.customerCompanyInfoGet(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
